<template>
      <div class="chart-box" ref="chart1"></div>

</template>

<script>
import {echartsMixin} from 'assets/js/common/mixin.js'
import {dataZoom} from 'assets/js/common/echartsComm.js'
  export default {
    name: "quantity",
    mixins: [echartsMixin,dataZoom],
    component:{},
    data(){
      return {
        chart1:'',
        ageORsexData: {
					age: ["生猪", "奶牛", "肉羊", "肉鸡", "鱼"],
					num: ["12", "10", "9", "6", "22"],
				},
      }
    },
    mounted(){
    	this.chart1 = this.$echarts.init(this.$refs.chart1)
    	this.initOption()
    },
    methods: {
       initOption(){
       	let option1 = {
					color: ['#3398DB'],
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							width:"30%",
							type: 'shadow',
							shadowStyle:{
								color:"rgba(8,104,98,0.36)"
							}
						},
						backgroundColor:"#002624",
						borderColor:'#009288',
						borderWidth:1,
						textStyle:{
							color:"#fff",
						},
						formatter:(params)=>{
							let html = "<div style='text-align:center;padding:15px'>"+params[0].name+"<br/>"     
								html+=`${params[0].seriesName}：<span style="color:#FF8A22;font-weight:bold;">${params[0].data}</span>`
							return html+'</div>'
						}
					},
					dataZoom:dataZoom,
					grid: {
            left: '20',
            right: '51',
            bottom: '30',
            top: "40",
            containLabel: true
          },
					xAxis: {
						name:'养殖\n品种',
						type: 'category',
						nameTextStyle:{
							color:"#99FFCC"
						},
						data: this.ageORsexData.age,
						boundaryGap: true, //坐标轴的留白
						axisLine: {
							show: true,
							lineStyle: {
								color: "#00C3D3",
							}
						},
						axisTick: {
							show: false //坐标轴刻度
						},
						axisLabel: {
							interval:0,
							color: '#fff',
							fontSize: 12,
							margin: 5
						},
						
					},
					yAxis: {
						type: 'value',
						name: '   单位（头/只）',
						nameTextStyle:{
              color:'#99FFCC',
              fontWeight: 'bold',
              padding: [0, 0, 0, 20],
            },
						axisTick: {
							show: false //坐标轴刻度
						},
						axisLine: {
              lineStyle: {
                color: "#35ece6",
                type: "solid",
                opacity:1
              }
            },
						axisLabel: {
//							show: false,
                color:"#fff"
						},
						splitLine: {
							show:false,
							lineStyle: {
								color: '#0C615B',
								type: "solid",

							}
						},
					},
					series: {
							name: '存栏量',
							type: 'bar',
							barWidth: 15,
//							smooth: true,
							itemStyle: {
								normal: {
									color: "rgba(24,95,109,0.75)",
									borderColor:"#00BCD1"
								},
							},
							data: this.ageORsexData.num
						},
				}
       	this.chart1.setOption(option1)
       },
       _resizeHanlder(){
       	this.chart1.resize()
       },
       _destroyHandler(){
       	if (this.chart1) {
       		this.chart1.dispose()
       	}
       }
    }
  }
</script>

<style lang="scss" scoped>
  
  .chart-box{
  	width: 100%;
  	height: calc(100% - 30px);
  	
  }
</style>



// WEBPACK FOOTER //
// src/pages/pollute/charts/quantitativeAnalysis.vue